import { LitElement, html } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { TechniquesSectionLabels } from '../../../edrIncidentDetails/types';
import { Subtechnique, Tactic, Technique } from '../../../../xdr/tacticsAndTechniques/types';
import { GzLinkWebComponent } from '../../../../ui/gzLinkComponent';
import { FontSizes, FontWeights } from '../../../../types/common/types';
import { getUniqueTechniquesAndSubtechniques } from '../../../../utils/xdr.utils';

/**
 * @summary Type here the description of this component
 * @tag incident-details-techniques-section
 * Here https://custom-elements-manifest.open-wc.org/analyzer/getting-started/ you can find out how to document the code
 */
@customElement('incident-details-techniques-section')
export class IncidentDetailsTechniquesSectionWebComponent extends LitElement {
  @property({ attribute: false })
  translations: TechniquesSectionLabels;

  @property({ attribute: false })
  mitreTags: Array<Tactic> = [];

  // see https://lit-element.polymer-project.org/guide/styles
  static get styles() {
    return styles;
  }

  render() {
    const techniques = getUniqueTechniquesAndSubtechniques(this.mitreTags);

    return html` <div class="title-container d-flex flex-row mb-2">
        <gz-title
          fontSize="${FontSizes.PARAGRAPH_11}"
          fontWeight="${FontWeights.SEMIBOLD}"
          class="section-title w-auto text-uppercase"
          >${this.translations.sectionTitle}
        </gz-title>
        <gz-text
          fontSize="${FontSizes.PARAGRAPH_10}"
          fontWeight="${FontWeights.LIGHT}"
          class="counter w-auto text-uppercase"
          >(${techniques.length})
        </gz-text>
      </div>
      ${this.renderAllMitreTags(techniques)}`;
  }

  renderAllMitreTags(techniques: Array<Technique>) {
    return techniques.map((technique: Technique) => {
      return html` <gz-labeled-content label="${technique.name}">
        ${this.renderTechnique(technique)}
      </gz-labeled-content>`;
    });
  }

  renderTechnique(technique: Technique) {
    if (!technique.subtechniques || technique.subtechniques.length === 0) {
      const gzLinkWebComponent = new GzLinkWebComponent();
      gzLinkWebComponent.fontSize = FontSizes.PARAGRAPH_12;

      gzLinkWebComponent.innerHTML = Application.lib.edrUtils.generateMitreLink(technique.id);
      return html` <div class="mitre-container d-flex flex-row align-items-center">${gzLinkWebComponent}</div>`;
    }

    return technique.subtechniques.map((subtechnique: Subtechnique) => {
      const gzLinkWebComponent = new GzLinkWebComponent();
      gzLinkWebComponent.fontSize = FontSizes.PARAGRAPH_12;

      gzLinkWebComponent.innerHTML = Application.lib.edrUtils.generateMitreLink(technique.id, subtechnique.id);
      return html` <div class="mitre-container d-flex flex-row align-items-center">
        ${gzLinkWebComponent}
        <div class="separator">-</div>
        <gz-tooltip isEllipsis tooltiptext="${subtechnique.name}">
          <gz-text
            class="subtechnique-name"
            fontSize="${FontSizes.PARAGRAPH_12}"
            fontWeight="${FontWeights.NORMAL}"
            lineheight="1.3"
            >${subtechnique.name}
          </gz-text>
        </gz-tooltip>
      </div>`;
    });
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'incident-details-techniques-section': IncidentDetailsTechniquesSectionWebComponent;
  }
}
